import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const followUser = createAsyncThunk('followUser/followUser', async (data) => {
    console.log(data)
    try {
        const res = await axios({
            method: 'post',
            url: process.env.REACT_APP_API_URL + `follower`,
            data: {
                "follower_id": data?.follower_id,
                "following_id": data?.following_id,
                "user_status": data?.status
            },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }
        })
        return res
    } catch (error) {
        return error.response
    }
})

